import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import {
  AffiliateTrackerCallbackParams,
  AffiliateTrackerInterface,
} from "src/app/interfaces/affliation-interface";
import { EventsService } from "../event/event.service";
//import pfRIC from "request-idle-callback";
import { UserSessionService } from "../user-session/user-session.service";
import { UtilsService } from "../utils/utils.service";
import Cookies from "js-cookie";
import { XtremepushService } from './xtremepush.service';
import { IncomeAccessTracker } from "./incomeaccess-tracker";
import { MetaPixelTracker } from "./metaPixelTracker";
import { GoogleTracker } from "./google-tracker";
import { AppsflyerService } from "./appsflyer.service";

@Injectable({
  providedIn: "root",
})
export class MarketingService {
  protected isInitialized: boolean = false;
  protected attributionData: any;

  constructor(
    protected platform: Platform,
    protected utils: UtilsService,
    protected events: EventsService,
    protected userSession: UserSessionService,
    protected xtremepushTracker: XtremepushService,
    protected incomeAccessTracker: IncomeAccessTracker,
    protected metaPixelTracker: MetaPixelTracker,
    protected googleTracker: GoogleTracker,
    protected appsFlyerTracker: AppsflyerService

  )
  // protected googleTracker: GoogleTracker,
  // protected pixelTrackerProvider: PixelTracker,
  // protected affiliateProvider: CakeAffiliateProvider,
  // protected incomeAccessMobileTracker: IncomeAccessMobileTracker,
  // protected tealiumTracker: TealiumTracker,
  // protected facebookTracker: FacebookAppevents,

  {
    this.events.subscribe("event:affiliation:initialize", () => {
      this.initialize();
    });
  }

  public initialize() {
    if (!this.isInitialized) {
      this.init();
      this.isInitialized = true;
    }
  }

  protected affiliateTrackers(): Array<AffiliateTrackerInterface> {
    return this.platform.is("capacitor")
      ? [
        // MOBILE Trackers
        this.appsFlyerTracker,
        this.googleTracker,
        // this.incomeAccessMobileTracker,
        // this.facebookTracker,
        // this.tealiumTracker,
        // this.xtremepushTracker,
      ]
      : [
        // WEB trackers
        this.googleTracker,
        this.incomeAccessTracker,
        this.metaPixelTracker,
        // this.tealiumTracker,
        // this.xtremepushTracker,
      ];
  }

  /**
   * Initialize the affiliate tracking depending on whether we are web (Cake) or mobile (Kochava)
   */
  private init(): Promise<any> {
    this.captureAffiliateParams();
    // init is only called once
    // this.events.unsubscribe("event:signupstep1complete");
    // this.events.unsubscribe("event:signupcomplete");
    // this.events.unsubscribe("event:deposit");
    // this.events.unsubscribe("event:login");
    // this.events.unsubscribe("event:withdraw");
    // this.events.unsubscribe("event:gameLaunched");
    // this.events.unsubscribe("event:login:error");
    // this.events.unsubscribe("event:close:account");
    // this.events.unsubscribe("password:reset");
    // this.events.unsubscribe("sports:place:bet");
    // this.events.unsubscribe("sports:add:bet");
    // this.events.unsubscribe("event:history:push");
    // this.events.unsubscribe("event:bonusActiveClicked");
    // this.events.unsubscribe("event:Totalbonus");
    // this.events.unsubscribe("event:bonusForfeit");
    // this.events.unsubscribe("event:RFBbonusForfeit");
    // this.events.unsubscribe("event:RFBbonusStatus");
    // this.events.unsubscribe("event:bonusCTAActivity");
    // this.events.unsubscribe("sports:widegtInteraction");
    // this.events.unsubscribe("event:BonusOffer");
    // this.events.unsubscribe("event:bonusCTASelection");

    return Promise.all(
      this.affiliateTrackers().map((tracker: AffiliateTrackerInterface) =>
        tracker
          .initialize()
          .then(() => {
            if (tracker) {
              this.setupEvents(tracker);
            }
          })
          .catch((e) => {
            console.log("tracker initialize failure: ", e);
          })
      )
    );
  }

  protected setupEvents(tracker: AffiliateTrackerInterface) {

    if ("function" === typeof tracker.signupStep1Complete) {
      this.events.subscribe(
        "event:signupstep1complete",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.signupStep1Complete(cbParams)
        // )
      );
    }
    if ("function" === typeof tracker.signupComplete) {
      this.events.subscribe(
        "event:signupcomplete",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.signupComplete(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.login) {
      this.events.subscribe(
        "event:login",
        (cbParams: any) =>
          // pfRIC.requestIdleCallback(
          //   () => {
          tracker.login(cbParams)
        // }
        //  )
      );
    }
    if ("function" === typeof tracker.loginError) {
      this.events.subscribe(
        "event:login:error",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.loginError(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.deposit) {
      this.events.subscribe(
        "event:deposit",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.deposit(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.withdraw) {
      this.events.subscribe(
        "event:withdraw",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.withdraw(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.gameLaunched) {
      this.events.subscribe(
        "event:gameLaunched",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.gameLaunched(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.forgotPassword) {
      this.events.subscribe(
        "event:password:reset",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.forgotPassword(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.closeAccount) {
      this.events.subscribe(
        "event:close:account",
        (cbParams: AffiliateTrackerCallbackParams) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.closeAccount(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.conversion) {
      this.events.subscribe("event:conversion:set", (cbParams: AffiliateTrackerCallbackParams) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.conversion(cbParams)
        //)
      );
    }
    if ("function" === typeof tracker.log) {
      this.events.subscribe(
        "event:log",
        (cbParams: any) =>
          //pfRIC.requestIdleCallback(() => 
          tracker.log(cbParams)
        // )
      );
    }
    if ("function" === typeof tracker.betPlaced) {
      this.events.subscribe("event:bet:server", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.betPlaced(data)
        //)
      );
    }
    if ("function" === typeof tracker.sendPageHistoryEvent) {
      this.events.subscribe("event:history:push", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.sendPageHistoryEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.logout) {
      this.events.subscribe("event:tracker:logout", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.logout()
        //)
      );
    }
    if ("function" === typeof tracker.gameClosed) {
      this.events.subscribe("event:tracker:gameClosed", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.gameClosed()
        //)
      );
    }
    if ("function" === typeof tracker.sportsBookWidgetTracking) {
      this.events.subscribe("sports:widegtInteraction", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.sportsBookWidgetTracking(data)
        //)
      );
    }
    if ("function" === typeof tracker.bonusListView) {
      this.events.subscribe("event:Totalbonus", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.bonusListView(data)
        //)
      );
    }
    if ("function" === typeof tracker.bonusDetailsView) {
      this.events.subscribe("event:bonusActiveClicked", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.bonusDetailsView(data)
        //)
      );
    }
    if ("function" === typeof tracker.bonusForfeitEvent) {
      this.events.subscribe("event:bonusForfeit", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.bonusForfeitEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.bonusCTAClickedEvent) {
      this.events.subscribe("event:BonusOffer", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.bonusCTAClickedEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.RFBbonusForfeitEvent) {
      this.events.subscribe("event:RFBbonusForfeit", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.RFBbonusForfeitEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.RFBbonusStatusEvent) {
      this.events.subscribe("event:RFBbonusStatus", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.RFBbonusStatusEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.bonusCTASelectionEvent) {
      this.events.subscribe("event:bonusCTASelection", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.bonusCTASelectionEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.promoCTAClickedEvent) {
      this.events.subscribe("event:promoCTAClicked", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.promoCTAClickedEvent(data)
        //)
      );
    }
    if ("function" === typeof tracker.promoOptInClickedEvent) {
      this.events.subscribe("event:promoOptInClicked", (data) =>
        //pfRIC.requestIdleCallback(() => 
        tracker.promoOptInClickedEvent(data)
        //)
      );
    }
  }

  /**
   * get the affiliate data from the affiliateTracker (Cake or Kochava)
   */
  getAttributionData(): Promise<any> {
    if (!this.isInitialized) {
      return this.captureAffiliateParams$();
    } else {
      return this.getSavedAttributionData();
    }
  }

  private getSavedAttributionData(): Promise<any> {
    return new Promise(resolve => {
      this.getAppsflyerData().then((appsflyerData: any) => {
        if (appsflyerData && appsflyerData.appsflyer != null) {
          if (!this.attributionData) {
            //If appsflyer has data and attributionData is undefined 
            this.attributionData = appsflyerData;
          } else if (!this.attributionData.hasOwnProperty("appsflyer")) {
            //If current attributionData is already defined and appsflyer Data is not found
            const currentData = this.attributionData;
            this.attributionData = { data: currentData, appsflyer: appsflyerData.appsflyer };
          }
        }
        resolve(this.attributionData);
      })
    })
  }

  captureAffiliateParams(): any {
    this.captureAffiliateParams$().then((attributionData: any) => {
      if (attributionData) {
        this.affiliateTrackers()
          .filter(
            (tracker: AffiliateTrackerInterface) =>
              "function" === typeof tracker.setAttributionData
          )
          .map((tracker: AffiliateTrackerInterface) =>
            tracker.setAttributionData(attributionData)
          );
        this.attributionData = attributionData;
      }
    });
  }

  protected captureAffiliateParams$(): Promise<any> {
    this.isInitialized = true;

    this.userSession.getCustomer().subscribe((customer: any) => {
      if (customer && customer.customerAttributionData) {
        var attributionData =
          "string" === typeof customer.customerAttributionData
            ? JSON.parse(customer.customerAttributionData)
            : customer.customerAttributionData;

        this.affiliateTrackers()
          .filter(
            (tracker: AffiliateTrackerInterface) =>
              "function" === typeof tracker.setAttributionData
          )
          .map((tracker: AffiliateTrackerInterface) =>
            tracker.setAttributionData(attributionData)
          );
      }
    });

    var urlParams: any = this.utils.getUrlParams();

    const btag_cookie: string = this.utils.getCookieParams("btag");
    // check if "btag" is set that if the value is empty/undefined or "undefined" - then do no pass it to webservices
    if (btag_cookie && btag_cookie !== undefined) {
      urlParams.btag = btag_cookie;
    }

    this.affiliateTrackers()
      .filter(
        (tracker: AffiliateTrackerInterface) =>
          "function" === typeof tracker.captureParameters
      )
      .map((tracker: AffiliateTrackerInterface) => tracker.captureParameters())
      .map((paramList: Array<string>) => {
        paramList.map((param: string) => {
          if ("undefined" !== typeof urlParams[param]) {
            Cookies.set("BTAG", JSON.stringify(urlParams), {
              domain: this.utils.getDomain(),
            });
            return Promise.resolve(urlParams);
          }
        });
      });

    var raw_attr_data: string = this.utils.getCookieParams("BTAG");
    var cookie_data: any = null;

    if (raw_attr_data) {
      try {
        cookie_data = JSON.parse(raw_attr_data);
      } catch {
        cookie_data = null;
      }
    }

    return Promise.resolve(cookie_data);
  }

  private getAppsflyerData(): Promise<any> {
    return new Promise(resolve => Promise.all(
      this.affiliateTrackers()
        .filter((tracker: AffiliateTrackerInterface) => ("function" === typeof tracker.getAttributionData))
        .map((tracker: AffiliateTrackerInterface) => tracker.getAttributionData())
    ).then((affiliateDatas: Array<any>) => {
      affiliateDatas.forEach((affiliateData) => {
        if (affiliateData !== null) {
          resolve(affiliateData);
        }
      });
    }));
  }

  getAppnexusData() {
    return this.utils.getCookieParams("appnexus");
  }
}
